import { ListingPageUrlState } from '../../redux/products/types';
import { CategoryEntity } from '../../redux/category/types';
import { PageType } from '../UrlManager/types';
import { BrazeClientInterface } from './BrazeClient';

export enum CustomEvents {
    landingView = 'landingView',
    searchView = 'searchView',
    newProductView = 'newProductView',
    brandView = 'brandView',
    categoryView = 'categoryView',
    reviewsReminderOverlayClose = 'reviewsReminderOverlayClose',
    readyForOverlays = 'session_start_IAM_eligible',
}

export enum CustomPDPEvents {
    addedToCart = 'addedToCart',
}

interface ProductProperty {
    sku: string;
    quantity: string;
}

export const sendCustomEventForPlp = async (braze: BrazeClientInterface, listingPageState: ListingPageUrlState) => {
    switch (listingPageState.listingPageType) {
        case PageType.LANDING: {
            await braze.logCustomEvent(CustomEvents.landingView, { name: listingPageState.listingPageKey });
            break;
        }
        case PageType.NEWPRODUCTS: {
            await braze.logCustomEvent(CustomEvents.newProductView, {});
            break;
        }
        case PageType.BRANDS: {
            await braze.logCustomEvent(CustomEvents.brandView, { name: listingPageState.listingPageKey });
            break;
        }
        default: {
            break;
        }
    }
};

export const sendCustomEventForPDP = async (
    braze: BrazeClientInterface,
    eventName: CustomPDPEvents,
    productProperty: ProductProperty
) => {
    return braze.logCustomEvent(eventName, productProperty);
};

export const sendCustomEventForSearch = async (
    braze: BrazeClientInterface,
    search: string,
    numberOfProducts: number
) => {
    /* eslint-disable-next-line @typescript-eslint/camelcase */
    await braze.logCustomEvent(CustomEvents.searchView, { name: search, number_of_products: numberOfProducts });
};

export const sendCustomEventForCategory = async (braze: BrazeClientInterface, category: CategoryEntity) => {
    await braze.logCustomEvent(CustomEvents.categoryView, {
        name: category.name,
        level: `PLP-${category.depthLevel}`,
        id: category.id,
    });
};

export const sendCustomEventForRatingClosed = async (braze: BrazeClientInterface, simpleSku: string) => {
    await braze.logCustomEvent(CustomEvents.reviewsReminderOverlayClose, {
        sku: simpleSku,
    });
};

export const sendCustomEventReadyForOverlays = async (braze: BrazeClientInterface) => {
    await braze.logCustomEvent(CustomEvents.readyForOverlays, {});
};

export default { sendCustomEventForPlp };
